import { IdentityUserText, type IdentityUserDetailItem } from "./identity-user-text";

export type AuditActorDetailItem = IdentityUserDetailItem;

export type AuditActorTextProps = {
  actorId?: string | null;
  username?: string | null;
  realName?: string | null;
  fallback?: string;
  detailItems?: AuditActorDetailItem[];
};

export function AuditActorText({
  actorId,
  username,
  realName,
  fallback = "CONTRACT_MISSING:audit_actor",
  detailItems,
}: AuditActorTextProps) {
  return (
    <IdentityUserText
      {...(actorId === undefined ? {} : { userId: actorId })}
      {...(username === undefined ? {} : { username })}
      fallback={fallback}
      {...(() => {
        const resolvedDetailItems = detailItems ?? (realName ? [{ key: "real-name", value: realName }] : undefined);
        return resolvedDetailItems === undefined ? {} : { detailItems: resolvedDetailItems };
      })()}
    />
  );
}
